import { simpleSet } from '@r/reducers/utils';

const setWireframeMode = simpleSet as redux.reducers.flags.wireframeMode;
export const wireframeMode = setWireframeMode(
  'SET_WIREFRAME_MODE',
  false
);
